"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppContext = exports.AppContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  Context: AppContext,
  useContext: useAppContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'AppContext'
});
exports.useAppContext = useAppContext;
exports.AppContext = AppContext;